//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.DokumentyASpisy.ts                   </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-01-04                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Lists {
    const { gcontent } = Decorators

    @gcontent
    export class DokumentyASpisy extends GContentBase<Gordic.Ssl.List> {

        gridUserSettings?: string;

        gsubtasksDiv: JQuery<HTMLElement>;

        prizRezimUtaj: boolean;
        
        public onContentReady():void {
            var that: DokumentyASpisy = this;
           
            //this.newOps({ title: "jres:31950083" }); //RC 31950083 : Dokumenty a Spisy
            this.actions.addRange({
                noact: { run: $.noop },
             /*   act2: { icon: "fa-bookmark", run: $.noop },
                act3: { icon: "fa-book", run: $.noop },*/
            });

            this.FilterFavoriteLayoutDescriptor = "L4M2S1";
           
            //this.menuBar(
            //    this.actions.createBar(["actPredatWfl*", "actPridelitWfl*", "-", "actVlozitDoSpisuSsl", "actVlozitEpkWfl", "actPoznamkovyBlokPridatSsl", "-", "actOznacitJakoPrecteneSsl", "actOznacitJakoNeprecteneSsl", "-", "actObcerstvitWfl"]) //RC 26255317 : Další
            //);
           
            this.gsubtasksDiv = $("<div>").appendTo(this.element)
                .gsubtasks({
                    params: [
                        { caption: "jres:31950067", action: this.actions.actVsechny }, //RC 31950067 : Všechny aktivní
                        { caption: "jres:31950064", action: this.actions.actNevyrizene }, //RC 31950064 : Nevyřízené
                        { caption: "jres:31950065", action: this.actions.actVyrizene }, //RC 31950065 : Vyřízené
                        { caption: "jres:31950066", action: this.actions.actNeaktivni } //RC 31950066 : Neaktivní
                    ]
                });
            
            // samotná definice gfilterpanelu
            this.FilterFavoriteLayoutDescriptor = "L4M3S1";
            this.staticFilters = [
                {
                    gfilterpanel_name: "Vše",
                    gfilterpanel_poznamka: "Pevný filtr",
                   // gfilterpanel_is_default: true,
                    DateInterval: null,
                    TypEntity: 1,
                    Doruceni:99,
                },
                {
                    gfilterpanel_name: "Vše za poslední rok",
                    gfilterpanel_poznamka: "Pevný filtr",
                    gfilterpanel_is_default: true,
                    DateInterval: {
                        date: {
                            start: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
                            end: new Date()
                        }
                    },
                    TypEntity: 1,
                    Doruceni: 99,
                }
            ]
            this.loadGridImmediately = false;
            this.SetParamsSubtaskFilterPanel(
                "ssd_ptm_sezdok",
                ["dateIntervalRow", "TypEntity", "Doruceni", "Vec", "Odesilatel", "Vlastni"],
                "filterSeznamDokSpi"
            );
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.Reload( obj.filter);
                })
                
                //.gfilterpanel({
                //    forms: null, // poleFormu ktere budou pouzity pro podminky
                //    simpleMode: true,
                //    favoriteLayoutDescriptor: "L3M2S1",
                //})
                
                ;
            if (this.model.SubTask !== Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vsechny && this.model.SubTask !== Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Neurceno) {
                this.activateSubtask(this.model.SubTask,false);

            }
            this.PrepareSubtask();
        }

        private activateSubtask(subTask: Pod.WebControls.Lists.DokumentyASpisySSDSubTask , invoke: boolean = false): void {
            var numToAcivate = 0;
            switch (subTask) {

                case Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vsechny:
                    numToAcivate = 0;
                    break;
                case Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Nevyrizene:
                    numToAcivate = 1;
                    break;
                case Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vyrizene:
                    numToAcivate = 2;
                    break;
                case Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Neaktivni:
                    numToAcivate = 3;
                    break;
                default:
                    numToAcivate = 0;
            }

            if (numToAcivate != 0) {
                this.gsubtasksDiv.gsubtasks('setActive', numToAcivate, invoke);
            }
            
        }     

        CreateFilterForms = function() {
            var that = this;
            var dateFactors = null;
            //var filtrVcetneOdeslanychVisible = false;
            //var filtrElektronickeVisible = false;
            //var filtrZnackaVisible = false;
            //var actNevyrizeneVisible = false;
            if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vsechny) {
                dateFactors = [
                    { caption: "jres:31950271", factor: "DP" }, //RC 31950271 : Podání
                    { caption: "jres:31950272", factor: "DZ" }, //RC 31950272 : Změna
                    { caption: "jres:31950273", factor: "DV" }, //RC 31950273 : Vyřízení
                ];

               // filtrElektronickeVisible = true;
               // filtrZnackaVisible = true;

               // actNevyrizeneVisible = true;
            } else if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Nevyrizene) {
                dateFactors = [
                    { caption: "jres:31950271", factor: "DP" }, //RC 31950271 : Podání
                    { caption: "jres:31950272", factor: "DZ" }, //RC 31950272 : Změna
                ];

               // filtrElektronickeVisible = true;
               // filtrZnackaVisible = true;

               // actNevyrizeneVisible = true;
            } else if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vyrizene) {
                dateFactors = [
                    { caption: "jres:31950272", factor: "DZ" }, //RC 31950272 : Změna
                    { caption: "jres:31950273", factor: "DV" }, //RC 31950273 : Vyřízení
                ];

             //  filtrVcetneOdeslanychVisible = true;
            } else if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Neaktivni) {
                dateFactors = [
                    { caption: "jres:31950272", factor: "DZ" }, //RC 31950272 : Změna
                ];
            }
        
            //this.printRestrictionALF = "poz_blo";
            this.printRestrictionALF = null;
            //this.actions.actPredatWfl.visible(actNevyrizeneVisible);
            //this.actions.actPridelitWfl.visible(actNevyrizeneVisible);
            //this.actions.actVlozitDoSpisuSsl.visible(actNevyrizeneVisible);
            //this.actions.actVlozitEpkWfl.visible(actNevyrizeneVisible);
            var filterForm =
                new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "jres:23900049", layoutDescriptor: "L2M2S1, L-12-11-1, M-12-11-1, S-12-11-1, breaks-700-1000" }) //RC 23900049 : Kompletní filtr
                .addSection()
                    .addRow({ label: "jres:31950071", name: "dateIntervalRow" }) //RC 31950071 : Od-do
                    .addField("gdatecombobox", {
                        name: "dateIntervalField",
                        //defaultInitialValue: this.model.DateInterval,
                        model: "model.DateInterval=value; model.DatumAplikovatNa=factor",
                        factors: dateFactors,
                        daysRangeMax: that.DaysRangeMax, //dsebesta 30.11.2020 potencionální kvízy ze to lidi chcou neomezene hned parametr "ssl_superadmin"
                        userSettings: that.userSettings,
                        contextMenu: {
                            daysRange: that.predplneniPocetDni
                        },
                        change: function (ev, obj) {

                        },

                    })
                .addRow("jres:31950347").addField("gselectbox", { //RC 31950347 : Typ entity
                    list: true,
                    name: "TypEntity",
                    data: new Gordic.Data.View([
                        { val: Pod.WebControls.Lists.DokumentyASpisyTypEntity.Vsechny, text: "jres:31950337" }, //RC 31950337 : Všechny
                        { val: Pod.WebControls.Lists.DokumentyASpisyTypEntity.Spisy, text: "jres:31950338" }, //RC 31950338 : Spisy
                        { val: Pod.WebControls.Lists.DokumentyASpisyTypEntity.Dokumenty, text: "jres:31950339" }, //RC 31950339 : Dokumenty
                        { val: Pod.WebControls.Lists.DokumentyASpisyTypEntity.MimoSpis, text: "jres:31950340" }, //RC 31950340 : Mimo spis
                        { val: Pod.WebControls.Lists.DokumentyASpisyTypEntity.VeSpisu, text: "jres:31950341" }, //RC 31950341 : Ve spisu
                    ], { key: "val" }),
                    itemTooltipTemplate: (value) => {
                        if (value) { 
                            switch (value.val) {
                                case Pod.WebControls.Lists.DokumentyASpisyTypEntity.Vsechny:
                                    return "jres:31950342"; //RC 31950342 : Všechny dokumenty i spisy
                                case Pod.WebControls.Lists.DokumentyASpisyTypEntity.Dokumenty:
                                    return "jres:31950343"; //RC 31950343 : Pouze dokumenty
                                case Pod.WebControls.Lists.DokumentyASpisyTypEntity.Spisy:
                                    return "jres:31950344"; //RC 31950344 : Pouze spisy
                                case Pod.WebControls.Lists.DokumentyASpisyTypEntity.MimoSpis:
                                    return "jres:31950345"; //RC 31950345 : Pouze dokumenty mimo spis
                                case Pod.WebControls.Lists.DokumentyASpisyTypEntity.VeSpisu:
                                    return "jres:31950346"; //RC 31950346 : Pouze dokumenty ve spisu
                                default:
                                    return null;
                            }
                        }
                        return null;
                    },
                    itemTemplate: "{text}",
                    model: "model.TypEntity=value.val",
                    itemWidth: "",
                    initialValue: { val: this.model.TypEntity },
                    
                })
                //s_prij
                .addRow("jres:31950348").addField("gselectbox", { //RC 31950348 : Doručení
                    list: true,
                    name: "Doruceni",
                    data: new Gordic.Data.View([
                        { val: 99, text: "Všechny" },
                        { val: Gordic.Wfl.Interface.WflcsprEnum.VlastniDokument, text: "jres:31950349" }, //RC 31950349 : Vlastní
                        { val: Gordic.Wfl.Interface.WflcsprEnum.CiziDokument, text: "jres:31950350" }, //RC 31950350 : Doručený
                    ], { key: "val" }),
                    itemTemplate: "{text}",
                    model: "model.Doruceni=value.val",
                    itemWidth: "",
                    initialValue: {val:this.model.Doruceni },

                })
                .addRow("jres:31950351").addField("gstringbox", { //RC 31950351 : Věc
                    name: "Vec",
                    initialValue: this.model.Vec,
                })
                .addRow("jres:31950352").addField("gstringbox", { //RC 31950352 : Odesílatel
                    name: "Odesilatel",
                    initialValue: this.model.Odesilatel,
                })
                
                .addRow().addField("gcheck", {
                    name: "Vlastni",
                    label: "jres:31950353", //RC 31950353 : Vlastní
                    initialValue: this.model.Vlastni,
                })


                .addRow("jres:31950387").addField("gselectbox", Gordic.Prefabs.Select.gincstu(), //RC 31950387 : Přístup
                {
                    name: "StUtajId",
                    model: "model.StUtajId=value.st_utaj_id",
                    serverFilters: {
                        //st_utaj_id_orig: componentDto.IRPUzivatelMaIRPNesmiPrepnoutNaRizenyPristup ? "!= 40" : undefined,
                        gintreu: this.prizRezimUtaj ? true : undefined

                    },
                });

                ;
            return [filterForm]; 
        }
        LoadGrid = function (this: DokumentyASpisy) {
            var that = this;
            var gridColumnsDefinition = new Gordic.Data.GridFormat();
            gridColumnsDefinition.addIconColumn(this.VysledekOperaceIcoColumn());
            (Gordic.Wfl as any).GWflCommonDlg.AddSSDDokumentyColumnsDlg(gridColumnsDefinition, {}); // extendObj nepovinné
            if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vsechny) {
                this.gridUserSettings = "gridVsechny";
                gridColumnsDefinition
                    /*.addIconColumn(Gordic.Wfl.Globals.ListSupport.TypDokumentuColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.EleColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.SchvalenoColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.PuvodColumn()) // stare ikony*/
                    .addTextColumn(Gordic.Wfl.Globals.ListSupport.PrizCjColumn())
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.PrizBalikColumn())
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.UzoColumn(
                        null,
                        function (row) {
                            return row.ixs_fun_akt != that.IxsFunAkt;
                            return false;
                        },
                        this.globalSettings
                    ))

                    .addTextColumn({
                        name: "ixp",
                        caption: "jres:31950072", //RC 31950072 : PID
                        width: 120,
                        // fixedWidth: true,
                    })
                    .addTextColumn({
                        name: "akt_znacka",
                        caption: this.ZnackaShortText,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                        //sortOrder: Gordic.Ssl.Utils.SortSpzn 
                    })
                    .addTextColumn({
                        name: "cj_spis",
                        caption: (this as any).SpZnackaShortText ,  //this.SpZnackaShortText
                        width: 150,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "misto_vzniku",
                        caption: "jres:31950073", //RC 31950073 : Odesílatel
                        width: 200,
                    })
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:31950074", //RC 31950074 : Věc-obsah
                        width: 250,
                    })
                    .addDateTimeColumn({
                        name: "dat_zmena",
                        caption: "jres:31950069", //RC 31950069 : Datum změny
                    })
                    .addTextColumn({
                        name: "vlastnik",
                        caption: "jres:31950075", //RC 31950075 : Vlastník
                        width: 200,
                    })
                    .addDateTimeColumn({
                        name: "dat_pod",
                        caption: "jres:31950068", //RC 31950068 : Datum podání
                    })
                    .addDateColumn({
                        name: "dat_vyriz",
                        caption: "jres:31950334", //RC 31950334 : Datum vyřízení
                        width: 100,
                    })
                    .addDateColumn({
                        name: "dat_vyriz_do",
                        caption: "jres:31950076", //RC 31950076 : Termín dok.
                        width: 100,
                    })
                    .addTextColumn({
                        name: "spis_znak",
                        caption: "jres:31950077", //RC 31950077 : Spis. znak
                        //  aggregate: Gordic.Data.Aggregates.first("ac"),
                        groupings: {
                            default: {
                                _presetCaption: "jres:31950319", //RC 31950319 : Spis. znak
                                grouping: {
                                    //hash: function (meta, rows) {
                                    //    var d = meta.data;
                                    //    return d.spis_znak;
                                    //  //  return d.nazev && d.nazev.length > 0 ? d.nazev.charAt(0).toUpperCase() : null;
                                    //},
                                    sort: "spis_znak,spis_pl,ixp",
                                    hideColumn: false
                                }
                            }
                        },
                        filter: [new Gordic.Wfl.Utils.GTextFilterFullTextStartsWith("spis_znak")]
                    })
                    .addTextColumn({
                        name: "spis_pl",
                        caption: "jres:31950318", //RC 31950318 : Spis. plán
                    })
                    //.addTextColumn({
                    //    name: "ixs_typ_txt",
                    //    caption: "jres:31950078", //RC 31950078 : Typ dokumentu
                    //})
                    .addTextColumn({
                        name: "poznamka",
                        caption: "jres:31950313", //RC 31950313 : Poznámka
                    })
                    .addTextColumn({
                        name: "zkr_ag",
                        caption: "jres:31950389", //RC 31950389 : Typ agendy
                        width: 70,
                    })
                    .addTextColumn({
                        name: "uziv_sl_1",
                        caption: this.UzivSlA,
                    })
                    .addTextColumn({
                        name: "uziv_sl_2",
                        caption: this.UzivSlB,
                    })
                    .addTextColumn({
                        name: "uziv_sl_3",
                        caption: this.UzivSlA2,
                    })
                    .addTextColumn({
                        name: "uziv_sl_4",
                        caption: this.UzivSlB2,
                    });

            } else if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Nevyrizene ) {
                this.gridUserSettings = "gridNevyrizene";
                gridColumnsDefinition
                    /*.addIconColumn(Gordic.Wfl.Globals.ListSupport.TypDokumentuColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.EleColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.SchvalenoColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.PuvodColumn()) // stare ikony*/
                    .addTextColumn(Gordic.Wfl.Globals.ListSupport.PrizCjColumn())
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.UzoColumn(
                        null,
                        function (row) {
                            return row.ixs_fun_akt != that.IxsFunAkt;
                            return false;
                        },
                        this.globalSettings
                    ))
                
                    .addTextColumn({
                        name: "ixp",
                        caption: "jres:31950072", //RC 31950072 : PID
                        width: 120,
                    })
                    .addTextColumn({
                        name: "akt_znacka",
                        caption: this.ZnackaShortText,
                        width: 100,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "cj_spis",
                        caption: (this as any).SpZnackaShortText, 
                        width: 150,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "misto_vzniku",
                        caption: "jres:31950073", //RC 31950073 : Odesílatel
                        width: 200,
                    })
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:31950074", //RC 31950074 : Věc-obsah
                        width: 250,
                    })
                    .addDateTimeColumn({
                        name: "dat_zmena",
                        caption: "jres:31950069", //RC 31950069 : Datum změny
                    })
                    .addTextColumn({
                        name: "vlastnik",
                        caption: "jres:31950075", //RC 31950075 : Vlastník
                        width: 200,
                    })
                    .addDateTimeColumn({
                        name: "dat_pod",
                        caption: "jres:31950068", //RC 31950068 : Datum podání
                    })
                    .addDateColumn({
                        name: "dat_vyriz_do",
                        caption: "jres:31950076", //RC 31950076 : Termín dok.
                        width: 100
                    })
                    .addTextColumn({
                        name: "spis_znak",
                        caption: "jres:31950077", //RC 31950077 : Spis. znak
                        //  aggregate: Gordic.Data.Aggregates.first("ac"),
                        groupings: {
                            default: {
                                _presetCaption: "jres:31950319", //RC 31950319 : Spis. znak
                                grouping: {
                                    //hash: function (meta, rows) {
                                    //    var d = meta.data;
                                    //    return d.spis_znak;
                                    //  //  return d.nazev && d.nazev.length > 0 ? d.nazev.charAt(0).toUpperCase() : null;
                                    //},
                                    sort: "spis_znak,spis_pl,ixp",
                                    hideColumn: false
                                }
                            }
                        },
                        filter: [new Gordic.Wfl.Utils.GTextFilterFullTextStartsWith("spis_znak")]
                    })
                    .addTextColumn({
                        name: "spis_pl",
                        caption: "jres:31950318", //RC 31950318 : Spis. plán
                    })
                    //.addTextColumn({
                    //    name: "ixs_typ_txt",
                    //    caption: "jres:31950078", //RC 31950078 : Typ dokumentu
                    //})
                    .addTextColumn({
                        name: "poznamka",
                        caption: "jres:31950313", //RC 31950313 : Poznámka
                    })
                    .addTextColumn({
                        name: "zkr_ag",
                        caption: "jres:31950389", //RC 31950389 : Typ agendy
                        width: 70,
                    })
                    .addTextColumn({
                        name: "uziv_sl_1",
                        caption: this.UzivSlA,
                    })
                    .addTextColumn({
                        name: "uziv_sl_2",
                        caption: this.UzivSlB,
                    })
                    .addTextColumn({
                        name: "uziv_sl_3",
                        caption: this.UzivSlA2,
                    })
                    .addTextColumn({
                        name: "uziv_sl_4",
                        caption: this.UzivSlB2,
                    });

            } else if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vyrizene) {
                this.gridUserSettings = "gridVyrizene";
                gridColumnsDefinition
                    /*  .addIconColumn(Gordic.Wfl.Globals.ListSupport.TypDokumentuColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.EleColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.StavDokColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.SchvalenoColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.PuvodColumn()) // stare ikony*/
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.PrizBalikColumn())
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.UzoColumn(
                        null,
                        function (row) {
                            return row.ixs_fun_akt != that.IxsFunAkt;
                            return false;
                        },
                        this.globalSettings
                    ))
                    .addTextColumn({
                        name: "ixp",
                        caption: "jres:31950072", //RC 31950072 : PID
                        width: 120,
                    })
                    .addTextColumn({
                        name: "akt_znacka",
                        caption: this.ZnackaShortText,
                        width: 100,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "cj_spis",
                        caption: (this as any).SpZnackaShortText,
                        width: 150,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "misto_vzniku",
                        caption: "jres:31950073", //RC 31950073 : Odesílatel
                        width: 200,
                    })
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:31950074", //RC 31950074 : Věc-obsah
                        width: 250,
                    })
                    .addTextColumn({
                        name: "spis_znak",
                        caption: "jres:31950077", //RC 31950077 : Spis. znak
                        //  aggregate: Gordic.Data.Aggregates.first("ac"),
                        groupings: {
                            default: {
                                _presetCaption: "jres:31950319", //RC 31950319 : Spis. znak
                                grouping: {
                                    //hash: function (meta, rows) {
                                    //    var d = meta.data;
                                    //    return d.spis_znak;
                                    //  //  return d.nazev && d.nazev.length > 0 ? d.nazev.charAt(0).toUpperCase() : null;
                                    //},
                                    sort: "spis_znak,spis_pl,ixp",
                                    hideColumn: false
                                }
                            }
                        },
                        filter: [new Gordic.Wfl.Utils.GTextFilterFullTextStartsWith("spis_znak")]
                    })
                    .addTextColumn({
                        name: "spis_pl",
                        caption: "jres:31950318", //RC 31950318 : Spis. plán
                    })
                    .addTextColumn({
                        name: "skar_znak",
                        caption: "jres:31950079", //RC 31950079 : Skar.znak
                    })
                    .addNumberColumn({
                        name: "skar_lhuta",
                        caption: "jres:31950080", //RC 31950080 : Skar.lhuta
                    })
                    .addDateTimeColumn({
                        name: "dat_pod",
                        caption: "jres:31950068", //RC 31950068 : Datum podání
                    })
                    .addDateColumn({
                        name: "dat_vyriz",
                        caption: "jres:31950334", //RC 31950334 : Datum vyřízení
                        width: 100,
                    })
                    .addDateTimeColumn({
                        name: "zp_vyriz_txt",
                        caption: "jres:31950081", //RC 31950081 : Zp. vyřízení ČJ
                    })
                    .addTextColumn({
                        name: "poznamka",
                        caption: "jres:31950313", //RC 31950313 : Poznámka
                    })
                    .addTextColumn({
                        name: "zkr_ag",
                        caption: "jres:31950389", //RC 31950389 : Typ agendy
                        width: 70,
                    })
                    .addTextColumn({
                        name: "uziv_sl_1",
                        caption: this.UzivSlA,
                    })
                    .addTextColumn({
                        name: "uziv_sl_2",
                        caption: this.UzivSlB,
                    })
                    .addTextColumn({
                        name: "uziv_sl_3",
                        caption: this.UzivSlA2,
                    })
                    .addTextColumn({
                        name: "uziv_sl_4",
                        caption: this.UzivSlB2,
                    });
            } else if (this.model.SubTask == Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Neaktivni) {
                //var l_bUseTypPisemnostiEnum = this.model.ZobrazitNeaktivniFilter === Gordic.Ssl.Globals.Enums.SeznamNeaktivnich.ODESLANE; // u techto seznamu jina logika na ikony
                this.gridUserSettings = "gridVyrizene";
                gridColumnsDefinition
                    /* .addIconColumn(Gordic.Wfl.Globals.ListSupport.TypDokumentuColumn()) // stare ikony
                    .addIconColumn(Gordic.Wfl.Globals.ListSupport.EleColumn()) // stare ikony*/
                    .addTextColumn({
                        name: "ixp",
                        caption: "jres:31950072", //RC 31950072 : PID
                        width: 120,
                    })
                    .addTextColumn({
                        name: "akt_znacka",
                        caption: this.ZnackaShortText,
                        width: 100,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "cj_spis",
                        caption: (this as any).SpZnackaShortText,
                        width: 150,
                        sortOrder: Gordic.Ssl.Utils.SortSpzn
                    })
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:31950074", //RC 31950074 : Věc-obsah
                        width: 250,
                    })
                    //.addTextColumn({
                    //    name: "ixs_typ_txt",
                    //    caption: "jres:31950078", //RC 31950078 : Typ dokumentu
                    //})
                    .addTextColumn({
                        name: "misto_vzniku",
                        caption: "jres:31950073", //RC 31950073 : Odesílatel
                    })
                    .addTextColumn({
                        name: "nazev_fun",
                        caption: "jres:31950082", //RC 31950082 : Poslední aktuální vlastník(funkce)
                    })
                    .addTextColumn({
                        name: "poznamka",
                        caption: "jres:31950313", //RC 31950313 : Poznámka
                    })
                    .addTextColumn({
                        name: "zkr_ag",
                        caption: "jres:31950389", //RC 31950389 : Typ agendy
                        width: 70,
                    })
                    ;
            }
            
            this.mainGrid.ggrid({
                name: "GridDocs",
                //    data: that.ViewTabulkaSubjektu,
                renderMode: "auto", // auto, all-at-once, paged-sync, paged-async
                columnMode: "full",  // fit (defaultne by melo byt toto), full
                customClass: "js-gridKartoteka",
                navigationMode: "row", // row, cell
                //userSettings: this.gridUserSettings ? this.gridUserSettings : undefined,
                defaultAction: new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                    name: "gridRowSelectedAct",
                    run: function (ev, ctx) {
                        var rowData = ctx.cellInfo.data; //data, ze kterych byl vytvoren radek
                        var options = {
                            ixp: rowData.ixp,
                            grid: that.mainGrid
                        };
                        var retPromis = (Gordic.Ssl as any).MainApp.ShowDetail(that, options);
                        if (retPromis) {
                            retPromis.done(function (cntDialogDiv) {
                                if (cntDialogDiv) {
                                    cntDialogDiv.on("closed", function (ev, dlgRet) {
                                        if (dlgRet && dlgRet.naDetailuDosloKeZmene) {
                                            //refresh řádku rowData.ixp
                                            that.Reload();
                                        }
                                    });
                                }
                            });
                        }
                    }
                }),
                contextMenu: function (cellContext) {
                    
                    return that.GetFullContextMenu();
                },
                //rowsClass: function (dataRow) {
                //    if(dataRow && dataRow.data && that.zvyrazneniNeprectenych && dataRow.data.priz_view_ssl == 10) {
                //        return " grid-noview-wfl-list ";
                //    } else return "  ";
                //},
                rowsClass: function (dataRow) {
                    return that.GetRowClass(dataRow);
                },
                multi: true,
                /*
                selection: function (ev, selectionInfo) {
                  
                    if (selectionInfo.count === 1) { // u single modu vzdy 1 ale pro jistotu testuji
                        var rowData = that.mainGrid.ggrid("getSelection");
                        var row = rowData[0];

                        that.aktualizujNahled(row);
                    }
                },
                */
                selection: function (ev, ctx) {
                    if (that.SelectionForPreviewController) {
                        var opt = {
                            ggrid: $(this)
                        };
                        that.SelectionForPreviewController(opt);
                    }
                },

                //     scrollHelperTemplate: "{nazev}",  // "{ixs_esu} - {nazev}",
                //searchColumns: ["ixp", "akt_znacka", "misto_vzniku", "nazev", "dat_zmena", "vlastnik", "dat_pod", "dat_vyriz_do", "spis_znak", "ixs_typ_txt", "uziv_sl_1", "uziv_sl_2", "uziv_sl_3", "uziv_sl_4"], //sloupce, podle kterych se vyhledava v searchboxu
                columns: gridColumnsDefinition,
            });


            //sluzba pro pristup k datum ze serveru //{className:"", params: {}
            //this.srv = new GContent({ className: "Gordic.Ssl.WebClient.TrasyDokumentuDlg", params: { MyFoo: "abc" } });  //sluzba pro pristup k datum na serveru + predani parametru

            this.LoadData();
        }
        private VyberRadkuClick(rowData):void {
            var that = this;
      
        }
        private NevyrizeneClick():void {
            this.model.SubTask = Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Nevyrizene;
            this.PrepareSubtask();
        }
        private VyrizeneClick(): void  {
            this.model.SubTask = Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vyrizene;
            this.PrepareSubtask();
        }
        private NeaktivniClick(): void  {
            this.model.SubTask = Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Neaktivni;
            this.PrepareSubtask();
        }
        private VsechnyClick(): void  {
            this.model.SubTask = Pod.WebControls.Lists.DokumentyASpisySSDSubTask.Vsechny;
            this.PrepareSubtask();
        }

        //#region Menu
      
        CreateMenu = function (): void {
            this.ZaregistrujHromadneAkce();
            // this.enableHromadneAkce(); // TODO

            var lokalniAkceBefore = [
                { action: "actDetailWfl", favorite: true },
                { action: "actOtevriDokumentDoNoveZalozkyVeStejneFazi", favorite: true },
                { type: "separator", id: "sep1" },
            ];
            var lokalniAkceAfter = [
                { type: "separator", id: "sep4" },
                { action: "actObcerstvitWfl" },
            ];
            var spolecneAkce = this.VratMenuHromadneAkce();
            var kompletniAkce = (lokalniAkceBefore as any).concat(spolecneAkce).concat(lokalniAkceAfter);
            this.CreateMenuBar(kompletniAkce);
        }

        getVisibleHromadneAkceDto = function () : Wfl.Interface.GHromadneWflAkceDto {
            var defaultDto = Gordic.Wfl.Globals.ListSupport.GetDefaultGHromadneWflAkceDto();


            //tato sekce je specifická pro každá content. vybereš si které chceš a které ne

            //!!!!!!!!!! Default je zde false
            var visible = false;
            defaultDto.PredatPrimo = true;
            defaultDto.PridelitHromadne = visible;
            defaultDto.PrevzitHromadne = visible;
            defaultDto.ZrusitPrideleniHromadne = visible;
            defaultDto.ZmenitPrideleniHromadne = visible;
            defaultDto.EvidovatHromadne = visible;
            defaultDto.OdeslatHromadne = visible;
            defaultDto.VyjmoutZeSpisuHromadne = true;
            defaultDto.VlozitDoSpisuSslHromadne = true;
            defaultDto.SouboryNearchivniFormat = visible;
            defaultDto.OpravaMetadatSeznamNew = true;
            defaultDto.OpravitMetadataPoKontroleSeznam = true;
            defaultDto.ZmenitFormuHromadne = visible;
            defaultDto.ZmenitDilciDokTerminHromadne = visible;
            defaultDto.ZmenitDoplnekZnackyHromadne = visible;
            defaultDto.ZmenitPocetListu = visible;
            defaultDto.ZmenitPocetPriloh = visible;
            defaultDto.ZmenitPocetListuPriloh = visible;
            defaultDto.ZmenitPoznamkuHromadne = visible;
            defaultDto.ZmenitPristupHromadne = visible;
            defaultDto.ZmenitSpisZnakHromadne = visible;
            defaultDto.ZmenitTerminSpisuHromadne = visible;
            defaultDto.ZmenitTypDokHromadne = visible;
            defaultDto.ZmenitVecHromadne = visible;
            defaultDto.ZmenitUmisteniHromadne = visible;
            defaultDto.ZmenitZpracovateleHromadne = visible;
            defaultDto.VlozitDokEpkHromadne = true;
            defaultDto.VlozitSpisEpkHromadne = true;
            defaultDto.VyriditAdActaHromadne = true;
            defaultDto.VyriditDokumentyHromadne = true;
            defaultDto.VyriditSpisyHromadne = true;
            defaultDto.ZrusitVyrizeniDokumentuHromadne = visible;
            defaultDto.ZrusitVyrizeniSpisuHromadne = visible;
            defaultDto.ZrusitUzavreniSpisuHromadne = visible;
            defaultDto.PrerusitHromadne = visible;
            defaultDto.PriorovatHromadne = visible;
            defaultDto.PredatExtAgHromadne = visible;
            defaultDto.PrevzitExtAgHromadne = visible;
            defaultDto.PridatKlSlovaHromadne = visible;
            defaultDto.OdebratKlSlovaHromadne = visible;
            defaultDto.VlozitDokumentSpisDoBaliku = true;
            defaultDto.VytvoritBalikAVlozitSeznam = true;
            defaultDto.PridatSpisyZDokumentuHromadne = visible;
            defaultDto.PridatDokumentyVlozeneDoSpisuHromadne = visible;
            defaultDto.PoznamkovyBlokPridatHromadne = visible;
            defaultDto.OznacitJakoPrecteneHromadne = true;
            defaultDto.OznacitJakoNeprecteneHromadne = true;
            defaultDto.TiskListWfl = true;
            defaultDto.TiskPevny = visible;
            defaultDto.Obcerstvit = visible;
            defaultDto.SchvalitHromadne = visible;
            // konec specifické sekce
            //defaultDto.EvidovatRozsirenyProfilHromadne = visible; 
            return defaultDto;
        }

        getEnableHromadneAkceDto = function () : Wfl.Interface.GHromadneWflAkceDto {
            var defaultDto = Gordic.Wfl.Globals.ListSupport.GetDefaultGHromadneWflAkceDto();

            return defaultDto;
        }
        
        
        getFavoriteHromadneAkceDto = function () : Wfl.Interface.GHromadneWflAkceDto  {
            var defaultDto = Gordic.Wfl.Globals.ListSupport.GetDefaultGHromadneWflAkceDto(false);

            // Defaultně jsou všechny true.

            defaultDto.PredatPrimo = true;
            defaultDto.OpravaMetadatSeznamNew = true;
            defaultDto.OpravitMetadataPoKontroleSeznam = true;
            defaultDto.VyriditAdActaHromadne = true;
            defaultDto.VyriditDokumentyHromadne = true;
            defaultDto.VyriditSpisyHromadne = true;
            defaultDto.VlozitDokumentSpisDoBaliku = true;
            defaultDto.VytvoritBalikAVlozitSeznam = true;

            return defaultDto;
        }
        
        //#endregion
    }
}
